/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from "@material-ui/core";
import React, { useEffect } from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import "./Profile.scss";
import { Text } from "sunrise-ui";
import { useNavigate } from "react-router-dom";
import { getProfileDetials } from "../../redux/reducers/profile";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { useSelector } from "react-redux";
import Loader from "../../utilities/Loader";

const Profile = () => {
  // -----------loader state------------
  let [loading, setLoading] = React.useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const profileData = useSelector((state: any) => state.PROFILE);
  const { profileDetails } = profileData;
  const { data } = profileDetails;
  console.log("data", data);
  useEffect(() => {
    setLoading(true);
    !profileDetails &&
      dispatch(
        getProfileDetials({
          endPoint: "general/get-user-by-mail",
        })
      ).then((res) => {
        setLoading(false);
      });
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  sessionStorage.setItem("userID", data?._id);
  return (
    <Sidebar>
      {loading ? (
        <Loader color="#5f67e0" loading={loading} size={20} height="80vh" />
      ) : (
        <Grid container className="profile_wrapper">
          <Grid item xs={12}>
            <Grid className="d-flex v-center mb2">
              <Grid className="profile_image_container mr-1">
                <img src={data?.userImage} alt="..." />
              </Grid>
              <Grid className="name_container">
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={20}
                  className="mb0 mt0"
                >
                  <span className="user_designation fw300 capitalize">
                    {data?.role}:{" "}
                  </span>
                  <span className="user_name fw500 capitalize">
                    {data?.name}
                  </span>
                </Text>
              </Grid>
            </Grid>
          </Grid>
          {/* ----------Name field---------- */}
          <Grid item xs={12}>
            <Text type="normal" fonts="normal" fontSize={16} className="mb mt0">
              <span className="fw500">Employee Name</span>
            </Text>
            <Grid className="disabled_field d-flex v-center mb1 capitalize">
              <span className="fw400 f14">{data?.name}</span>
            </Grid>
          </Grid>
          {/* ----------emoloyee id field--------- */}
          <Grid item xs={12}>
            <Text type="normal" fonts="normal" fontSize={16} className="mb mt0">
              <span className="fw500">Employee Id</span>
            </Text>
            <Grid className="disabled_field d-flex v-center mb1">
              <span className="fw400 f14">{data?.empId}</span>
            </Grid>
          </Grid>

          {/* ----------email id field---------- */}
          <Grid item xs={12}>
            <Text type="normal" fonts="normal" fontSize={16} className="mb mt0">
              <span className="fw500">Email Id</span>
            </Text>
            <Grid className="disabled_field d-flex v-center mb1">
              <span className="fw400 f14">{data?.emailId}</span>
            </Grid>
          </Grid>
          {/* -----------phone number field----------- */}
          <Grid item xs={12}>
            <Text type="normal" fonts="normal" fontSize={16} className="mb mt0">
              <span className="fw500">Phone Number</span>
            </Text>
            <Grid className="disabled_field d-flex v-center mb1">
              <span className="fw400 f14">
                {data?.mobileNumber?.primaryNumber}
              </span>
            </Grid>
          </Grid>
          {/* ----------------change password----- */}
          <Grid item xs={12}>
            <Grid className="t-center password_field">
              <Text
                type="link"
                fonts="normal"
                fontSize={16}
                onTextClick={() => {
                  navigate("/change_password");
                }}
              >
                <span className="fw500"> Change Password</span>
              </Text>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Sidebar>
  );
};

export default Profile;
